"use client";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { STORE_DEPARTMENTS_CLASSES } from "./constants";

export const StoreDepartmentsContainer = styled(Container)(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    display: "flex",

    [`& .${STORE_DEPARTMENTS_CLASSES.title}`]: {
      marginBottom: theme.spacing(2),
      ...theme.typography.h5,
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(4),
        ...theme.typography.h4,
      },
    },

    [`& .${STORE_DEPARTMENTS_CLASSES.departments}`]: {
      display: "flex",
      marginBottom: theme.spacing(7),
      [BREAKPOINT_DESKTOP]: { marginBottom: theme.spacing(8) },
    },

    [`& .${STORE_DEPARTMENTS_CLASSES.hideOnMobile}`]: {
      display: "none",
      [BREAKPOINT_TABLET]: {
        display: "flex",
      },
    },
  };
});
